import React from 'react';

export const ShoppingCart = () => (
    <>
        <circle cx='6' cy='19' r='2' />
        <circle cx='17' cy='19' r='2' />
        <path d='M17 17h-11v-14h-2' />
        <path d='M6 5l14 1l-1 7h-13' />
    </>
);